import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {SystemStickerType, TimetrackerBoardSettings} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {PageService} from '@extensions/page-service'
import {BoardFilters} from '@extensions/sticker/board-filters'
import {TimetrackingEditInner} from '@extensions/sticker/views-web/timetracking/timetracking-edit'

export const StickerMenuTimeTrackingTask = observer(() => {
  const [, store] = useStickerStore()
  const task = store.stickerTask

  const canEdit =
    !store.stickerTask ||
    PermissionsChecker.checkEditTaskStickers(
      store.stickerTask,
      store.sticker,
      undefined
    )

  const filtersController = BoardFilters.stickerFilterFromBoard(
    PageService.getCurrentBoard()
  )
  const board = filtersController.getTimetrackingBoard()
  const conf = board?.stickers?.[store.sticker.id] as
    | TimetrackerBoardSettings
    | undefined
  const isCompleted = Boolean(task && conf?.complete?.[task.location])

  return (
    <div className="min-w-[295px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showSettings={false}
          showUnpin={false}
        />
      </div>
      <div className="sticker-item-list-body">
        {task && (
          <TimetrackingEditInner
            sticker={store.sticker}
            task={task}
            complete={isCompleted}
            data={{
              containerKey: task.id
            }}
            close={store.closeStickerMenu}
            disabledPlan={!canEdit}
            disabledWork={false}
          />
        )}
      </div>
    </div>
  )
})
